<template>
  <span>
    <el-dialog
      :visible.sync="dialogVisible"
      :destroy-on-close="true"
      :close-on-click-modal="!submitting"
      :close-on-press-escape="!submitting"
      :show-close="!submitting"
      width="75%"
      top="5vh"
    >
      <div slot="title">
        <h3 class="title">{{ title }}</h3>
      </div>
      <el-alert
        class="price-update-alert"
        type="info"
        :title="$t('price_update_info')"
        :closable="false"
        show-icon
      />
      <dynamic-form
        ref="dynamicFormComponentRef"
        v-model="entity"
        :form="localForm"
        :default-search-engine="defaultSearchEngine"
        @isDomainSourceCorrectlyFormatted="
          handleDomainSourceIncorrectlyFormatted($event)
        "
        @isTargetUrlCorrectlyFormattedOrEmpty="
          handleTargetUrlIncorrectlyFormatted($event)
        "
        @pending-supplier-change="hasPendingSupplier = $event"
      >
      </dynamic-form>
      <div class="submit">
        <el-button
          :disabled="
            !isTargetUrlCorrectlyFormattedOrEmpty ||
            !isDomainSourceCorrectlyFormatted ||
            submitting
          "
          :loading="submitting"
          type="success"
          plain
          @click="submit(link)"
        >
          {{ $t("confirm") }}
        </el-button>
        <div
          v-if="hasPendingSupplier"
          class="pending-supplier-warning">
          {{ $t("pending_supplier_warning") }}
        </div>
        <div
          v-if="submitError"
          class="submit-error">
          {{ $t("submit_error") }}
        </div>
      </div>
    </el-dialog>
  </span>
</template>

<script>
import DynamicForm from "@/components/DynamicForm";

export default {
  components: {
    DynamicForm,
  },
  props: {
    title: String,
    value: Boolean,
    link: Object,
    defaultSearchEngine: Object,
  },
  data() {
    return {
      entity: {},
      localForm: this.link.form,
      isTargetUrlCorrectlyFormattedOrEmpty: false,
      isDomainSourceCorrectlyFormatted: false,
      submitting: false,
      submitError: false,
      hasPendingSupplier: false,
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.value;
      },
      set(dialogVisible) {
        this.$emit("input", dialogVisible);
      },
    },
  },
  watch: {
    value(visible) {
      if (visible) {
        this.hasPendingSupplier = false;
        this.submitError = false;
      }
    },
  },
  methods: {
    submit() {
      if (this.submitting) {
        return;
      }
      this.$refs.dynamicFormComponentRef.$refs.dynamicFormRef.validate(
        async (valid) => {
          if (!valid) {
            return;
          }
          this.submitting = true;
          this.submitError = false;
          try {
            await this.$refs.dynamicFormComponentRef.beforeSubmit();
          } catch (err) {
            this.submitting = false;
            this.submitError = true;
            return;
          }
          let details = {};
          details.entity = this.entity;
          details.link = this.link;
          this.$emit("add-entity", details);
          this.submitting = false;
          this.dialogVisible = false;
        }
      );
    },
    handleDomainSourceIncorrectlyFormatted(isDomainSourceCorrectlyFormatted) {
      this.isDomainSourceCorrectlyFormatted = isDomainSourceCorrectlyFormatted;
    },
    handleTargetUrlIncorrectlyFormatted(isTargetUrlCorrectlyFormattedOrEmpty) {
      this.isTargetUrlCorrectlyFormattedOrEmpty =
        isTargetUrlCorrectlyFormattedOrEmpty;
    },
  },
};
</script>

<style lang="scss" scoped>
.price-update-alert.el-alert--info {
  margin-bottom: 16px;
  background-color: #ecf5ff;
  color: #409eff;

  ::v-deep .el-alert__title {
    color: #409eff;
  }
}

.flex-box {
  display: flex;
  flex-direction: row;
}

.submit {
  margin-top: 1rem;
  text-align: center;
}

.submit-error {
  margin-top: 0.5rem;
  color: #f56c6c;
  font-size: 12px;
}

.pending-supplier-warning {
  margin-top: 0.5rem;
  color: #e6a23c;
  font-size: 12px;
}

.title {
  text-align: center;
}
</style>

<i18n>
{
  "en": {
    "confirm": "Confirm",
    "submit_error": "Something went wrong, please try again.",
    "pending_supplier_warning": "A new intermediary supplier will be created when you confirm.",
    "price_update_info": "The buying price entered will replace this supplier's offer price for this domain, whatever the backlink's status."
  },
  "fr": {
    "confirm": "Valider",
    "submit_error": "Une erreur est survenue, veuillez réessayer.",
    "pending_supplier_warning": "Un nouveau fournisseur intermédiaire va être créé à la validation.",
    "price_update_info": "Le prix d'achat saisi remplacera le prix de l'offre de ce fournisseur pour ce domaine, quel que soit le statut du backlink."
  },
  "de": {
    "confirm": "Bestätigen",
    "submit_error": "Etwas ist schiefgelaufen, bitte versuchen Sie es erneut.",
    "pending_supplier_warning": "Ein neuer Vermittler-Anbieter wird bei der Bestätigung erstellt.",
    "price_update_info": "Der eingegebene Einkaufspreis ersetzt den Angebotspreis dieses Anbieters für diese Domain, unabhängig vom Status des Backlinks."
  }
}
</i18n>
